export class BadCredentialsError extends Error {

  constructor(s) {
    super();
    this.message = s
  }

  toString() {
    return `BadCredentials: ${this.message}`
  }

}